import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { OfferListItem } from 'components/offer-list-item/offer-list-item';
import Picture from 'components/picture';
import { isWalmartOffer, isWalmartWeekOffer } from 'state/loyalty/hooks/utils/walmart';
import { LoyaltyOffer } from 'state/loyalty/types';

import { IncentiveCardDescription } from '../../loyalty-incentives-components/incentive-card/incentive-card.styled';
import { parseIncentiveData } from '../../loyalty-incentives-components/incentive-card/parse-incentive-data';
import { OffersServiceMode } from '../types';

interface IOffersInCartProps {
  offers: Array<LoyaltyOffer>;
  handlePress(incentive: LoyaltyOffer): void;
  handleRemove: (incentive: LoyaltyOffer) => void;
}

export const OffersInCart: FC<React.PropsWithChildren<IOffersInCartProps>> = ({
  offers,
  handlePress,
  handleRemove,
}) => {
  const { formatMessage } = useIntl();

  // A future ticket will change Remove handler to work at the item level.
  // For now this feature is used only with one offer in cart rule, so taking the first one is valid.
  const [firstOffer] = offers;

  return (
    <>
      {offers.map((offer, idx) => {
        const incentiveData = parseIncentiveData(offer);
        const {
          description,
          image,
          imageDescription,
          name: incentiveName,
          offerServiceMode,
        } = incentiveData;

        return (
          <OfferListItem
            key={offer.loyaltyEngineId || idx}
            image={<Picture image={image} alt={imageDescription} height="97px" width="97px" />}
            header={incentiveName}
            description={description && <IncentiveCardDescription content={description} />}
            onPress={() => handlePress(offer)}
            offerApplied
            offerText={formatMessage({ id: 'offerApplied' })}
            handleRemove={() => handleRemove(firstOffer)}
            removeOfferText={formatMessage({ id: 'remove' })}
            serviceModeStyle={
              offerServiceMode === OffersServiceMode.DELIVERY_ONLY
                ? 'default-outline'
                : 'default-solid'
            }
            isWalmartOffer={isWalmartOffer(offer)}
            isWalmartWeekOffer={isWalmartWeekOffer(offer)}
          />
        );
      })}
    </>
  );
};
